export const pluralize = (count: number, singular: string, pluralSuffix = 's'): string => {
  const label = count === 1 ? singular : `${singular}${pluralSuffix}`;
  return `${count} ${label}`;
};
